import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import objectPath from "object-path";
import { toAbsoluteUrl } from "../../../_helpers";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { useSelector, shallowEqual } from "react-redux";
import { CORPORATION } from "../../../../app/config/environment";
import { CORPS } from "../../../../app/config/helper";
export function Header() {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  const { auth } = useSelector(state => ({ auth: state.auth }), shallowEqual);
  const { user } = auth ?? {};

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          {/* begin::Left */}
          <div className="d-flex align-items-stretch mr-3">
            {/* begin::Header Logo */}
            <div className="header-logo">
              <Link to="/">
                <img
                  className="logo-default max-h-40px"
                  alt="Logo"
                  src={
                    user
                      ? user.organization && user.organization.image
                        ? `${user.organization.image.storage}/${user.organization.image.path}`
                        : CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                        ? toAbsoluteUrl("/media/logos/logo-letter-9.png")
                        : toAbsoluteUrl("/media/logos/donorian-logo-light.png")
                      : CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                        ? toAbsoluteUrl("/media/logos/logo-letter-9.png")
                        : toAbsoluteUrl("/media/logos/donorian-logo-light.png")
                  }
                />
                <img
                  className="logo-sticky max-h-40px"
                  alt="Logo"
                  src={
                    user
                      ? user.organization && user.organization.image
                        ? `${user.organization.image.storage}/${auth.user.organization.image.path}`
                        : CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                        ? toAbsoluteUrl("/media/logos/logo-letter-1.png")
                        : toAbsoluteUrl("/media/logos/donorian-logo.png")
                      : CORPORATION.toString().toUpperCase() == CORPS.SIMPZ
                      ? toAbsoluteUrl("/media/logos/logo-letter-1.png")
                      : toAbsoluteUrl("/media/logos/donorian-logo.png")
                  }
                />
              </Link>
            </div>
            {/* end::Header Logo */}
            {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          </div>
          {/* end::Left */}

          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
